<template>
  <v-expansion-panel>
    <template>
      <v-expansion-panel-header class="mt-2">
        Plantillas de pago a proveedores (BAC)

        <template v-slot:actions>
          <v-btn class="mr-5" @click.native.stop="reload()" icon small>
            <v-icon color="primary">mdi-reload</v-icon>
          </v-btn>
          <v-btn @click="$store.dispatch('deleteWindowByUuid',{uuid : win.uuid})" icon small>
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-tabs v-model="tab" dark background-color="primary" icons-and-text>
          <v-tabs-slider color="red"></v-tabs-slider>

          <v-tab href="#tab-1">
            Crear plantilla de pago
            <v-icon>mdi-plus-circle</v-icon>
          </v-tab>

          <v-tab href="#tab-2">
            Plantillas de pago
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-tab>

          <v-tab href="#tab-3">
            Vista previa contable
            <v-icon>mdi-file-document-outline</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" touchless>
          <v-tab-item value="tab-1">
            <v-card flat>
              <v-card-text class="pa-1">
                <CreatePaymentTemplate 
                  :win="win" 
                  :key="key" 
                  :initial-template-id="editingTemplateId"
                  @template-created="onTemplateCreated"
                  @template-updated="onTemplateUpdated"
                  @cancel-edit="onCancelEdit"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item value="tab-2">
            <v-card flat>
              <v-card-text class="pa-1">
                <ListPaymentTemplates 
                  :win="win" 
                  :key="keyList"
                  @use-template="onUseTemplate"
                  @edit-template="onEditTemplate"
                  @open-accounting-preview="openAccountingPreview"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item value="tab-3">
            <v-card flat>
              <v-card-text class="pa-1">
                <PaymentTemplateAccountingPreview
                  :key="keyPreview"
                  :initial-template-id="previewTemplateId"
                  :initial-mode="previewAccountingMode"
                  :activation-token="previewActivationToken"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-expansion-panel-content>
    </template>
  </v-expansion-panel>
</template>

<script>
import CreatePaymentTemplate from '@/views/acounting/partial/CreatePaymentTemplate.vue';
import ListPaymentTemplates from '@/views/acounting/partial/ListPaymentTemplates.vue';
import PaymentTemplateAccountingPreview from '@/views/acounting/partial/PaymentTemplateAccountingPreview.vue';

export default {
  name: "PaymentTemplate",
  components: {
    CreatePaymentTemplate,
    ListPaymentTemplates,
    PaymentTemplateAccountingPreview,
  },
  props: {
    win: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      tab: null,
      key: 0,
      keyList: 0,
      keyPreview: 0,
      editingTemplateId: null,
      previewTemplateId: null,
      previewAccountingMode: 'general',
      previewActivationToken: 0
    };
  },
  mounted() {
    // Lógica de inicialización si es necesaria
  },
  methods: {
    reload() {
      this.key++;
      this.keyList++;
      this.keyPreview++;
    },
    onTemplateCreated() {
      this.editingTemplateId = null;
      // Cambiar a la pestaña de lista y recargar
      this.tab = 'tab-2';
      this.keyList++;
      this.keyPreview++;
    },
    onTemplateUpdated() {
      this.editingTemplateId = null;
      this.tab = 'tab-2';
      this.keyList++;
      this.keyPreview++;
    },
    onUseTemplate(template) {
      // Aquí puedes implementar la lógica para procesar la plantilla
      console.log('Usar plantilla:', template);
    },
    onEditTemplate(templateId) {
      this.editingTemplateId = templateId;
      this.key++;
      this.tab = 'tab-1';
    },
    onCancelEdit() {
      this.editingTemplateId = null;
      this.tab = 'tab-2';
      this.key++;
    },
    openAccountingPreview(payload) {
      this.previewTemplateId = payload?.templateId || null;
      this.previewAccountingMode = payload?.accountingMode || 'general';
      this.previewActivationToken++;
      this.tab = 'tab-3';
    }
  }
};
</script>

<style scoped>
.text-body-1 {
  color: #666;
}
</style>
